import React from 'react'
import {Link} from 'react-router-dom'
import ReactGA from 'react-ga';

import '../../../public/assets/css/style.css'

ReactGA.initialize('UA-144557614-1');

function initializeGA(){
    ReactGA.pageview('/not-found')
}

function interaction({mCategory, mType}){
	ReactGA.event({
		category: mCategory,
		action: mType, 

	});
}

export default class PageNotFound extends React.Component{

    componentDidMount(){
       initializeGA();
    }


    render(){


        return(
    <div id="notfound">
		<div className="notfound">
			<div className="notfound-404">
				<h1>Oops!</h1>
				<h2>404 - A página não foi encontrada</h2>
			</div>
			<Link to="/" onClick={interaction("error", "backhome")}>Voltar para a Homepage</Link>
		</div>
	</div>
        ); 
    };
}


// WEBPACK FOOTER //
// ./src/common/PageNotFound/index.jsx